export const environment = {
  production: true,
  apiUrl: '/folha-pagamento-api',
  realm: 'OxyElotech',
  urlKeycloak: window.location.host.endsWith('oxy.elotech.com.br')
  ? 'https://openid.oxy.elotech.com.br/auth'
  : window.location.host.endsWith('qa.elotech.com.br')
    ? 'https://openid.qa.elotech.com.br/auth'
    : 'https://openid.dev.elotech.com.br/auth'
};
